import { render, staticRenderFns } from "./HrmHomePage.vue?vue&type=template&id=bebc9de4&"
import script from "./HrmHomePage.vue?vue&type=script&lang=js&"
export * from "./HrmHomePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports